
import { VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const ProviderInvoiceCategoryFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "number",
                        "name": "codigo",
                        "label": "Codigo",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 2
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "title",
                        "label": "Nombre",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "is_default",
                        "label": "Categorias por defecto",
                        "sizing": {
                            "sm": {
                                "offset": "2"
                            }
                        },
                    },
                ],
            ]
        }
    ],
};


export default ProviderInvoiceCategoryFormConfig;